import callAPiBase from './base';

const denylistApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/denylistList',
      method: 'GET',
      useToken: true,
      title: 'Denylist - Get List',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/denylistCreate',
      method: 'POST',
      useToken: true,
      title: 'Denylist - Create',
      data,
    }),
};

export { denylistApi };
export default denylistApi;
